import React from 'react';
import SeoHead from '../components/SeoHead';
import About from '../components/About';
import Process from '../components/Process';
import Testimonials from '../components/Testimonials';

const AboutPage = () => {
  return (
    <>
      <SeoHead
        title="About THINKINGWORLD"
        description="THINKINGWORLD is a product studio founded by Barani — building websites, apps, IoT and digital marketing engines. Founder-led, no black boxes, quality is non-negotiable."
        path="/about"
      />

      <header className="page-header">
        <div className="container">
          <span className="section-eyebrow">About us</span>
          <h1>A small team that takes software seriously.</h1>
          <p>
            THINKINGWORLD is a founder-led product studio, started by Barani.
            We design, build and grow real software for real businesses — and we
            stay around after launch.
          </p>
        </div>
      </header>

      <About />
      <Process />
      <Testimonials />
    </>
  );
};

export default AboutPage;
